// removed by extract-text-webpack-plugin
module.exports = {"root":"key-value-list--root--3ZTW35B2","row":"key-value-list--row--184yUQIb","column":"key-value-list--column--1zM6AO2M","label":"key-value-list--label--UCW-q7ob","value":"key-value-list--value--2xR6WTMZ","row-value":"key-value-list--row-value--2Q3U3PS-","rowValue":"key-value-list--row-value--2Q3U3PS-","column-value":"key-value-list--column-value--eIs7kQgT","columnValue":"key-value-list--column-value--eIs7kQgT","row-label":"key-value-list--row-label--3j-pUEgx","rowLabel":"key-value-list--row-label--3j-pUEgx"};


//////////////////
// WEBPACK FOOTER
// ./components/key-value-list/styles.css
// module id = ./components/key-value-list/styles.css
// module chunks = 0